import "../Styles/AboutContent.css";
import React from 'react';


const AboutContent =()=>{
   
    return(
        <div>
       
        </div>
    )
}

export default AboutContent;